import React, { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import './toaster.scss'

// Define the props interface
interface ToastProps {
  message: string
  duration?: number // Optional prop
  type: string
  onClose: () => void // Function prop
}

const Toast: React.FC<ToastProps> = ({
  message,
  duration = 3000,
  type = 'success',
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      onClose()
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose])

  if (!isVisible) return null

  return (
    <div className={`toaster animated fast slideInRight ${type}`}>
      <span
        className='close'
        onClick={() => {
          setIsVisible(false)
          onClose()
        }}
      >
        <X size={16} color='#fff' />
      </span>
      <p>{message}</p>
    </div>
  )
}

export default Toast
